import { render, staticRenderFns } from "./AiPPT.vue?vue&type=template&id=0627e744&scoped=true&"
import script from "./AiPPT.vue?vue&type=script&lang=js&"
export * from "./AiPPT.vue?vue&type=script&lang=js&"
import style0 from "./AiPPT.vue?vue&type=style&index=0&id=0627e744&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627e744",
  null
  
)

export default component.exports